import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {EdsEnvConfig} from "../../../environments/edsEnvConfiguration";
import {IResourcePath} from "../../models/common";
import {getResourceImagePath} from "../../models/view";
import {EDSngMediaService} from "../edsng-media.service";
import {setWindowTitle} from "../../commonUtil";
import {support_to_url} from "../../common/utils";

import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-help-page',
  templateUrl: './help-page.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./help-page.component.css', './help-page-mobile.component.css', './help-page-tablet.component.css']
})
export class HelpPageComponent implements OnInit  {
  resolution = "md";
  edsImages: any;

  constructor(private actSvc: ActionsService, private router: Router, private media: EDSngMediaService, public translate: TranslateService)   {
    this.edsImages = [
      { img: 'pwr_mgmt_design_center.png', url: '/acdc-ff-lite/?msg=%7B%22data%22%3A%7B%22application%22%3A%22acdc_lite_html%22%2C%22specs%22%3A%7B%22ic%22%3A%22viper318hd%3Abuck%22%2C%22input%22%3A%7B%22v%22%3A%7B%22min%22%3A90%2C%22max%22%3A265%7D%2C%22f%22%3A50%7D%2C%22output%22%3A%5B%7B%22v%22%3A12%2C%22r%22%3A2%2C%22i%22%3A0.5%7D%5D%7D%7D%2C%22action%22%3A%22new_design%22%7D' },
      { img: 'thermo-electrical_sim_for_comp_1.png', url: '/acswitch' },
      { img: 'thermo-electrical_sim_for_comp_2.png', url: '/schottkyferd' },
      { img: 'signal_conditioning_design_tools.png', url: '/filter/?msg=%7B"data"%3A%7B"application"%3A"filter_html"%7D%2C"action"%3A"new_design"%7D' },
      { img: 'nfc_inductance.png', url: '/antenna' },
      { img: 'uhf_link_budget.png', url: '/uhf-link-budget' },
      { img: 'nfc_tuning_circuit.png', url: '/nfc-tuningcircuit' },
    ];
  }

  ngOnInit() {
    this.media.sizeAlias.subscribe(x => {
      this.resolution = x;
    });
    setWindowTitle(null, this.translate);
  }

  getResourceImage(a: string, b: IResourcePath): string {
    return getResourceImagePath(a, b);
  }

  showPage(pageId: string) {
    this.actSvc.sendAction(AnalyticsActions.sendAnalyticsEvent('support_request', pageId, {details: pageId}));
    window.open(support_to_url(pageId), '_blank'); // La lang non viene passata a 'support_to_url' perchè i links finali non gestiscono la localizzazione
  }

  openTool(url: string) {
    window.open(url, '_blank');
  }
}
